if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute("aria-disabled") === "true") return;

  this.handleErrorMessage();

  this.submitButton.setAttribute("aria-disabled", true);
  this.submitButton.classList.add("loading");
  this.querySelector(".loading__spinner").classList.remove("hidden");

  const config = fetchConfig("javascript");
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  delete config.headers["Content-Type"];

  const formData = new FormData(this.form);
  if (this.cart) {
    formData.append(
      "sections",
      this.cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append("sections_url", window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        // handle errors as usual
        this.handleErrorMessage(response.description);
        this.error = true;
        return;
      } else if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "product-form",
          productVariantId: formData.get("id"),
          cartData: response,
        });
      this.error = false;

      const quickAddModal = this.closest("quick-add-modal");
      if (quickAddModal) {
        // 1. Hide quick view modal first
        quickAddModal.hide(true);

        // 2. AFTER modal is fully closed, update cart notification and bubble
        document.body.addEventListener(
          "modalClosed",
          () => {
            setTimeout(() => {
              // update cart drawer silently
              this.cart.renderContents(response);

              // show popup notification if cartBehavior = nothing or cartType = notification
              const cartBehavior = this.cart?.dataset?.cartBehavior || "drawer";
              const cartType = this.cart?.dataset?.cartType || "drawer";

              if (cartBehavior === "nothing" || cartType === "notification") {
                const cartNotification = document.querySelector("cart-notification");
                if (cartNotification) {
                  cartNotification.renderContents(response);
                  cartNotification.open();
                }

                const cartDrawer = document.querySelector("cart-drawer");
                if (cartDrawer && cartDrawer !== this.cart) {
                  cartDrawer.renderContents(response, true);
                }

                // update cart bubble instantly
                const bubble = document.getElementById("cart-icon-bubble");
                if (bubble && response.sections["cart-icon-bubble"]) {
                  bubble.innerHTML = new DOMParser()
                    .parseFromString(response.sections["cart-icon-bubble"], "text/html")
                    .body.innerHTML;
                }
              }
            });
          },
          { once: true }
        );
      } else {
        // no quickAddModal, do normal behavior:

        document.dispatchEvent(
          new CustomEvent("product:added", {
            detail: {
              id: formData.get("id"),
              cartData: response,
            },
          })
        );

        // Always update drawer if cart is drawer
        if (this.cart?.tagName === "CART-DRAWER") {
          this.cart.renderContents(response);
        }

        const cartBehavior = this.cart?.dataset?.cartBehavior || "drawer";
        const cartType = this.cart?.dataset?.cartType || "drawer";

        if (cartBehavior === "nothing" || cartType === "notification") {
          const cartNotification = document.querySelector("cart-notification");
          if (cartNotification) {
            cartNotification.renderContents(response);
            cartNotification.open();
          }

          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer && cartDrawer !== this.cart) {
            cartDrawer.renderContents(response, true);
          }

          const bubble = document.getElementById("cart-icon-bubble");
          if (bubble && response.sections["cart-icon-bubble"]) {
            bubble.innerHTML = new DOMParser()
              .parseFromString(response.sections["cart-icon-bubble"], "text/html")
              .body.innerHTML;
          }
        }
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.submitButton.classList.remove("loading");
      if (this.cart && this.cart.classList.contains("is-empty"))
        this.cart.classList.remove("is-empty");
      if (!this.error) this.submitButton.removeAttribute("aria-disabled");
      this.querySelector(".loading__spinner").classList.add("hidden");
    });
}

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
